import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import {
  AfterContentChecked,
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
import {
  TabPosition,
  TabStripTabComponent,
} from '@progress/kendo-angular-layout';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { GridColumnMap } from '~/front-models/gridColumnMap';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import {
  AccountSummary,
  RelationAccount,
} from '~/models/administration/account';
import { AccountSite } from '~/models/administration/accountSite';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { UserSummary } from '~/models/administration/user';
import { Chart } from '~/models/chart/chart';
import { CustomFieldSummary } from '~/models/modules/customField';
import { GridFieldSummary } from '~/models/modules/gridField';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { NoteSummary } from '~/models/modules/note';
import { StartEndDateChartResponseModel } from '~/models/modules/startEndDateChartResponseModel';
import { UnitOfMeasureSummary } from '~/models/modules/unitOfMeasure';
import { AccountsService } from '~/services/administration.ts/accounts';
import { QuantityFormatsService } from '~/services/administration.ts/quantity-formats';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { InventoriesService } from '~/services/modules/stocks/inventories';
import { IssueTransactionsService } from '~/services/modules/stocks/issue-transaction';
import { NotesService } from '~/services/modules/stocks/notes';
import { ReceiveTransactionsService } from '~/services/modules/stocks/receive-transactions';
import { UnitOfMeasuresService } from '~/services/modules/stocks/unit-of-measure';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import {
  LayoutManagerService,
  PORTAL_DATA,
} from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { NoteComponent } from '~/shared/components/note/note.component';
import { StockItemsService } from '~/services/modules/stocks/items';
import { unitOfMeasureTypes } from '~/shared/enums/unitOfMeasureTypes';
@Component({
    selector: 'uom-form',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StocksUnitOfMeasuresUpsertComponent
  extends MultiSiteAwareComponent
  implements OnInit, OnDestroy, AfterViewChecked, AfterContentChecked {
  _deactivatedFormTabsForm: boolean = false
  _deactivatedFormTabsGridData: Array<any> = [];
  _currentUser: UserSummary;
  _accountColumnsMap: GridColumnMap[] = [];
  _accounts: AccountSummary[];
  _selectedAccounts: any[] = [];
  _theme: string;
  // _isNew: boolean;
  _form: FormGroup;
  _active: boolean;
  _listbarcodegenerator: Array<any> = [];
  _isAutoGeneratingNumber: boolean;
  _invalidForm: boolean;
  _model: UnitOfMeasureSummary = null;
  _unitCode = new FormControl();
  _pageState: PageState;
  _kendoTabStripPosition: TabPosition = 'left';
  _innerWidth: any;
  _addClassActive: boolean = false;
  _editFormActive: boolean;
  _isCustomfieldsFormValue: boolean = false;
  _isAddTabFormValue: boolean = false;
  _isRenameFormValue: boolean = false;
  _selectedTabId: number;
  _selectedLabelId: number;
  _page = 'uom';
  _permissionScope = 'uom';
  _customTabs: any;
  _customFields: CustomFieldSummary[][] = [];
  _customFieldsValue: any = [];
  _customValidation: any[] = [];
  _additionalErrors: any[] = [];
  _selectedAccountIds: any[] = [];

  _customFieldsDictionary: { [key: string]: string } = {};
  _gridFieldText: GridFieldTextSummary[];
  _language: string = 'en';
  _selectedLabelObjectCode: any;
  _isRenameCustomFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  okCloseSubscription: any = null;
  _deactivatedFieldsForm: boolean = false;
  _deactivatedFieldsGridData: any[] = [];
  _ReceiveItemsActive: boolean = true;
  _InventoryItemActive: boolean = false;
  _IssueItemsActive: boolean = false;
  RecievePerDate: any;
  IssuePerDate: any;
  InventoryPerDate: any;
  _custominvalidForm: boolean;
  _invalidSubmit: boolean;
  _notes: NoteSummary[];
  _note: string;
  _isEditNote: boolean = false;
  _index: number;
  _userNewDataTabs: Array<any> = [];
  _dataTabs: Array<any> = [];
  _dataTabsSelected: Array<any> = [];
  _orderingTabsForm: boolean = false;
  _gridFieldAuth: GridFieldAuthorization[];
  _isMandatory: boolean = false;
  _editableNote: any;
  _requiredFieldNames: Array<any> = [];
  _requiredFields: Array<any> = [];
  _systemFields: Array<any> = [];
  _editedSystemFields: Array<any> = [];
  reloadlist: any;
  _isLiveEnterprise: boolean;

  _isEditForms: boolean = false;

  quantityFormat: string;
  digitNumber: number;

  unitOfMeasureChartDetail: StartEndDateChartResponseModel;
  unitOfMeasureChart: Chart;
  receiveUnitOfMeasureChart: Chart;
  issueUnitOfMeasureChart: Chart;
  inventoryUnitOfMeasureChart: Chart;

  _receiveGridColumns: GridFieldSummary[];
  _issueGridColumns: GridFieldSummary[];
  _inventoryGridColumns: GridFieldSummary[];
  _stockItemsGridColumns: GridFieldSummary[];

  openUnitOfMeasureForm: boolean = false;

  isUnitOfMeasureChartExpanded: boolean = true;
  isUnitOfMeasureGridExpanded: boolean = true;

  _isEnterprise: boolean;

  reactivate: boolean = false;
  reactivateItem: any;


  _receiveChartActive: boolean = false;
  _issueChartActive: boolean = false;
  _inventoryChartActive: boolean = false;
  _receiveChartWindowActive: boolean = false;
  _issueChartWindowActive: boolean = false;
  _inventoryChartWindowActive: boolean = false;
  //#region ViewChild
  @ViewChild('kendo_BarcodeGen_Unit_Code') kendoBarcodeGenUnitCode: ElementRef;
  @ViewChild('Kendo_Units_Multiplier_Numericbox')
  kendoUnitsMultiplierNumericbox: NumericTextBoxComponent;
  @ViewChild('Kendo_Unit_Name_Input') KendoUnitNameInput: ElementRef;
  @ViewChild('accountTab') accountTab: TabStripTabComponent;
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('note') note: NoteComponent;
  //#endregion
  //#region custom Fields Fix
  copyModelId: number;
  _customRequiredFields: Array<any> = [];
  //#endregion
  //#region  CTOR
  constructor(
    private _accountsService: AccountsService,
    private _stockItemsService: StockItemsService,
    private _unitOfMeasuresService: UnitOfMeasuresService,
    private _fb: FormBuilder,
    private _themeManager: ThemeManagerService,
    private _layoutManager: LayoutManagerService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _layoutComponent: LayoutComponent,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _securityService: SecurityService,
    private _customFieldsService: CustomFieldsService,
    private _gridFields: GridFieldsService,
    private _notesService: NotesService,
    public cdRef: ChangeDetectorRef,
    private quantityFormatsService: QuantityFormatsService,
    private _receiveTransactionService: ReceiveTransactionsService,
    private _issueTransactionService: IssueTransactionsService,
    private _inventoriesService: InventoriesService,
    private _sharedService: SharedService
  ) {
    super();
    this._isEnterprise = this._securityService.currentUser.isEnterprise;
    this._isLiveEnterprise = environment.liveEnterprise;

    this._getdata();

    this.LoadData();

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    this._layoutManager.applyOverly();

    if (
      this._pageState == PageState.EDIT ||
      this._pageState == PageState.VIEW ||
      this._pageState == PageState.COPY
    ) {
      this._selectedAccounts = (this._model?.unitOfMeasureAccounts ?? []).map(
        (x: any) => +(x.account?.id ?? x.accountId ?? x.id ?? x)
      );
      this._selectedAccountIds = [...this._selectedAccounts];
      if (this._pageState != PageState.COPY) {
        this._unitCode.setValue(this._model.code);
      }

      this._tabEnabled = this._selectedAccounts.length > 0;
    }
    this._currentUser = this._securityService.currentUser;

    //this.loadCustomFields(this._model?.id?.toString());
    //this.loadLabels();
    this._customFieldsService
      .getDeactivatedCustomFields('stock', this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(
          (x) => x.formTab.page === this._page
        );
      });

    if (this._model.id) {
      this._unitOfMeasuresService
        .getStockRecievePerDate(this._model.id)
        .subscribe((x: any) => {
          this.RecievePerDate = x;
        });

      this._unitOfMeasuresService
        .getStockIssuePerDate(this._model.id)
        .subscribe((x: any) => {
          this.IssuePerDate = x;
        });

      this._unitOfMeasuresService
        .getStockInventoryPerDate(this._model.id)
        .subscribe((x: any) => {
          this.InventoryPerDate = x;
        });
    }
  }
  //#endregion
  //#region LoadData
  async LoadData() {
    this.quantityFormat =
      await this.quantityFormatsService.getQuantityFormatForNumericTextBox();
    this.digitNumber = await this.quantityFormatsService.getDigitNumber(
      this.quantityFormat
    );
  }
  //#endregion
  //#region  _getdata
  _getdata() {
    this._model =
      this._sharedService.model && this._sharedService.model.model
        ? this._sharedService.model.model
        : null;
    this._pageState =
      this._sharedService.model && this._sharedService.model.pageState
        ? this._sharedService.model.pageState
        : null;
    this._active = true;

    if ((this._pageState === PageState.ADD || this._pageState === PageState.COPY) && this._model && this._model.id > 0) {
      this.copyModelId = this._model.id;
      this._model.id = null;
      this._model.code = null;
    }

    if (this._model && this._model.id) {
      this.LoadUnitOfMeasureChart();
    }
  }
  //#endregion

  //#region LoadUnitOfMeasureChart
  async LoadUnitOfMeasureChart() {
    this._unitOfMeasuresService
      .GetUnitOfMeasureChart(this._model.id)
      .pipe()
      .toPromise()
      .then(async (data: any) => {
        this.unitOfMeasureChartDetail = data;
        this.unitOfMeasureChart = data.chart;
        //set receive stats
        this.receiveUnitOfMeasureChart = new Chart();
        this.receiveUnitOfMeasureChart.series = this.unitOfMeasureChart.series.filter((f: { [x: string]: string; }) => f['name'] == 'Receive');
        this.receiveUnitOfMeasureChart.title = { text: 'Receive U/M Stats', align: 'center' };
        this.receiveUnitOfMeasureChart.chart = { ...this.unitOfMeasureChart.chart };
        this.receiveUnitOfMeasureChart.xaxis = { ...this.unitOfMeasureChart.xaxis };
        this.receiveUnitOfMeasureChart.stroke = { ...this.unitOfMeasureChart.stroke };
        this.receiveUnitOfMeasureChart.dataLabels = { ...this.unitOfMeasureChart.dataLabels };
        //set issue stats
        this.issueUnitOfMeasureChart = new Chart();
        this.issueUnitOfMeasureChart.series = this.unitOfMeasureChart.series.filter((f: { [x: string]: string; }) => f['name'] == 'Issue');
        this.issueUnitOfMeasureChart.title = { text: 'Issue U/M Stats', align: 'center' };
        this.issueUnitOfMeasureChart.chart = { ...this.unitOfMeasureChart.chart };
        this.issueUnitOfMeasureChart.xaxis = { ...this.unitOfMeasureChart.xaxis };
        this.issueUnitOfMeasureChart.stroke = { ...this.unitOfMeasureChart.stroke };
        this.issueUnitOfMeasureChart.dataLabels = { ...this.unitOfMeasureChart.dataLabels };
        //set inventory stats
        this.inventoryUnitOfMeasureChart = new Chart();
        this.inventoryUnitOfMeasureChart.series = this.unitOfMeasureChart.series.filter((f: { [x: string]: string; }) => f['name'] == 'Inventory');
        this.inventoryUnitOfMeasureChart.title = { text: 'Inventory U/M Stats', align: 'center' };
        this.inventoryUnitOfMeasureChart.chart = { ...this.unitOfMeasureChart.chart };
        this.inventoryUnitOfMeasureChart.xaxis = { ...this.unitOfMeasureChart.xaxis };
        this.inventoryUnitOfMeasureChart.stroke = { ...this.unitOfMeasureChart.stroke };
        this.inventoryUnitOfMeasureChart.dataLabels = { ...this.unitOfMeasureChart.dataLabels };
      });
    this._gridFields
      .getGridFieldsByPage('stockItems')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(
          'stockItems',
          data
        );
        this._stockItemsGridColumns = data;
      });
    this._gridFields
      .getGridFieldsByPage('receiveHistory')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(
          'receiveHistory',
          data
        );
        this._receiveGridColumns = data;
      });
    this._gridFields
      .getGridFieldsByPage('inventories')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(
          'inventories',
          data
        );
        this._inventoryGridColumns = data;
      });
    this._gridFields
      .getGridFieldsByPage('issueHistory')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(
          'issueHistory',
          data
        );
        this._issueGridColumns = data;
      });
  }
  //#endregion
  //#region stock items by unit of measures
  _getReceiveUM = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._stockItemsService.GetStockItemByUnitOfMeasureId(this._model.id, unitOfMeasureTypes.receive);
  }
  _getIssueUM = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._stockItemsService.GetStockItemByUnitOfMeasureId(this._model.id, unitOfMeasureTypes.issue);
  }
  _getInventoryUM = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._stockItemsService.GetStockItemByUnitOfMeasureId(this._model.id, unitOfMeasureTypes.inventory);
  }
  _openReceiveChartWindow(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this._receiveChartWindowActive = true;
  }
  _closeReceiveChartWindow() {
    this._receiveChartWindowActive = false;
  }
  _openIssueChartWindow(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this._issueChartWindowActive = true;
  }
  _closeIssueChartWindow() {
    this._issueChartWindowActive = false;
  }
  _openInventoryChartWindow(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this._inventoryChartWindowActive = true;
  }
  _closeInventoryChartWindow() {
    this._inventoryChartWindowActive = false;
  }

  //#endregion
  //#region  _getReceiveTransactions
  _getReceiveTransactions = (
    params?: any,
    model?: any
  ): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.unitOfMeasureChartDetail.startDate,
      endDate: this.unitOfMeasureChartDetail.endDate,
    };
    return this._receiveTransactionService.GetReceiveTransactionByUOM(
      this._model.id,
      startEndDate
    );
  };
  //#endregion

  //#region _getIssueTransactions
  _getIssueTransactions = (
    params?: any,
    model?: any
  ): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.unitOfMeasureChartDetail.startDate,
      endDate: this.unitOfMeasureChartDetail.endDate,
    };
    return this._issueTransactionService.GetIssueTransactionByUOM(
      this._model.id,
      startEndDate
    );
  };
  //#endregion

  //#region _getInventory
  _getInventory = (
    params?: any,
    model?: any
  ): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.unitOfMeasureChartDetail.startDate,
      endDate: this.unitOfMeasureChartDetail.endDate,
    };
    return this._inventoriesService.GetInventoriesByUOM(
      this._model.id,
      startEndDate
    );
  };
  //#endregion
  getPropByString(obj: any, propString: any) {
    if (!propString)
      return obj;

    var prop, props = propString.split('.');

    for (var i = 0, iLen = props.length - 1; i < iLen; i++) {
      prop = props[i];

      var candidate = obj[prop];
      if (candidate !== undefined) {
        obj = candidate;
      } else {
        break;
      }
    }
    if (obj)
      return obj[props[i]];


  }
  //#region ExpandCollapseUnitOfMeasureGrid
  ExpandCollapseUnitOfMeasureGrid(isExpand: boolean) {
    this.isUnitOfMeasureGridExpanded = !isExpand;
  }
  //#endregion

  //#region ExpandCollapseUnitOfMeasureChart
  ExpandCollapseUnitOfMeasureChart(isExpand: boolean) {
    this.isUnitOfMeasureChartExpanded = !isExpand;
  }
  //#endregion

  //#region ngAfterContentChecked
  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }
  //#endregion

  //#region ngAfterViewChecked
  ngAfterViewChecked(): void {
    // this._initForm();
  }
  //#endregion

  //#region  ngOnInit
  ngOnInit() {
    this.loadLabels();
    this._initForm();
    this._viewInactiveFormTabs(true);
    this._pageState;

    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.kendoBarcodeGenUnitCode.nativeElement.focus();
      }, 500);
    }
    if (!this._currentUser.isEnterprise) {
      this._tabEnabled = true;
    }
    if (this._pageState === 3)
      if (this._model.id) this.getNotes(this._model.id, this._page);

    this.getFormTabs();
    //this.getSystemFields();
    this.getSystemFieldsAndCustomFields();
    this.getAuth();
    //this.setMandatoryFields();
    setTimeout(() => {
      this._activateReceiveChart();
    }, 100);
  }
  //#endregion

  //#region UnitOfMeasureChartOnActive
  UnitOfMeasureChartOnActive() {
    this.openUnitOfMeasureForm = true;
  }
  //#endregion
  UnitOfMeasureChartOnClose() {
    this.openUnitOfMeasureForm = false;
  }

  _ReceiveItemsTabClick() {
    this._ReceiveItemsActive = true;
    this._InventoryItemActive = false;
    this._IssueItemsActive = false;
  }
  _InventoryItemTabClick() {
    this._InventoryItemActive = true;
    this._ReceiveItemsActive = false;
    this._IssueItemsActive = false;
  }
  _IssueItemsTabClick() {
    this._IssueItemsActive = true;
    this._InventoryItemActive = false;
    this._ReceiveItemsActive = false;
  }

  _viewInactiveFields() {
    this._customFieldsService
      .getDeactivatedCustomFields('stock', this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(
          (x) => x.formTab.page === this._page
        );
      });
    // this._deactivatedFieldsForm = true;
  }
  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }

  _reactivate(item: any) {
    this.reactivateItem = item;
    this.reactivate = true;
    const sub = this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService
          .reactivateCustomField(this.reactivateItem.id, item)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  //this.loadCustomFields(this._model?.id?.toString());
                  this.getSystemFieldsAndCustomFields();
                  // this._deactivatedFieldsForm = false;
                } else {
                  return;
                }
              }
            }
            // this._deactivatedFieldsForm = false;
          });
        // this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name,
    });
    // this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }

  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    } else {
      if (!this._selectedAccounts.length) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the desired account in the Accounts Tab',
          withoutConfirm: true
        });
      } else {
        this._pageState = PageState.EDIT_FIELDS;
        //this._editFormActive = true;
        //this._isCustomfieldsFormValue = true;
      }
    }
  }

  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }
  _addNewField(tabId: number) {
    this._selectedTabId = null;
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }
  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set

    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }
  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }
  _returnAdNew() {
    this._pageState = PageState.ADD;
    if (this._deactivatedFormTabsGridData?.length == 0) {
      this._viewInactiveFormTabs(true);
    }
  }

  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
  }

  _getAccounts = (
    params?: any,
    model?: any
  ): Observable<DataWithPagingMetadata<any>> => {
    return this._accountsService.getAccounts(params, model);
  };

  _barcodeSubmited() {
    this._unitCode.setValue(this._form.get('code').value);
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.KendoUnitNameInput.nativeElement.focus();
        let UnitName = this.KendoUnitNameInput;
        UnitName.nativeElement.classList.add('focusedInput');
      });
    }
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
  }
  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;
    if (e === 'minimized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    } else if (e === 'maximized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    } else if (e === 'default') {
      element.el.nativeElement.classList.add('fullWidthFormForm');
    }
  }

  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }
  _generateBarcodeClick() {
    this.runGenerateBarcode();
  }
  _edit() {
    this._pageState = PageState.EDIT;
    this.accountTab.selected = true;
    this.accountTab.disabled = false;
  }

  private runGenerateBarcode() {
    let counter = 1;
    this.generateBarcode(counter).subscribe((data: any) => {
      this._unitCode.setValue(data.result.toString());
      this._form.patchValue({
        code: data.result.toString(),
      });
    });
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.KendoUnitNameInput.nativeElement.focus();
        this._addClassActive = false;
        let UnitName = this.KendoUnitNameInput;
        UnitName.nativeElement.classList.add('focusedInput');
      });
    }
  }
  _unitNameSubmited() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.kendoUnitsMultiplierNumericbox.focus();
        this._addClassActive = false;
        let UnitName = this.KendoUnitNameInput;
        UnitName.nativeElement.classList.remove('focusedInput');
      });
    }
  }
  _onFocusUnitName() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.KendoUnitNameInput.nativeElement.focus();
        this._addClassActive = false;
        let UnitName = this.KendoUnitNameInput;
        UnitName.nativeElement.classList.add('focusedInput');
      });
    }
  }

  CheckIfWeAreInEditMode() {
    var isEditMode: boolean = false;

    if (this._pageState == PageState.EDIT) {
      isEditMode = true;
    }

    return isEditMode;
  }

  _onFocusOutUnitName() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.KendoUnitNameInput.nativeElement.blur();
        let UnitName = this.KendoUnitNameInput;
        UnitName.nativeElement.classList.remove('focusedInput');
      }, 100);
    }
  }
  _unitsMultiplerSubmited() {
    if (this._pageState == PageState.ADD) {
      this._addClassActive = true;
      this.kendoUnitsMultiplierNumericbox.blur();
    }
  }
  _onFocusUnitsMultiplier() {
    if (this._pageState == PageState.ADD) {
      this._addClassActive = false;
    }
  }
  _onFocusUnitCode() {
    if (this._pageState == PageState.ADD) {
      this._addClassActive = false;
    }
  }

  _onFocusOutUnitCode() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.kendoBarcodeGenUnitCode.nativeElement.blur();
      });
    }
  }
  _skipUnitName() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        let UnitName = this.KendoUnitNameInput;
        UnitName.nativeElement.classList.remove('focusedInput');
        this.KendoUnitNameInput.nativeElement.blur();
        this.kendoUnitsMultiplierNumericbox.focus();
      });
    }
  }
  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService.getBarcode(this._page, quantity);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this._innerWidth = window.innerWidth;
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
  }
  _onSave(e: any) {
    this.submit(e);
  }

  _onEditForm() { }

  _onCancel(poModel: any = null) {
    this._closeForm(this.saveresponsthenclose ?? false);
  }

  _closeForm(poModel: any = null) {

    this.reloadlist = this._sharedService.model.reload;
    var closeComponent = {
      component: 'uom',
      isClosed: true,
      response: this.reloadlist === undefined ? null : poModel
    };


    this._gridLayoutManagerService.setGridDataSubjects('uom');
    this._layoutManager.setFromChanged('uom');
    this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};

  }

  _onAccountRowSelectionChanges(e: AccountSite[]) {
    super._onAccountRowSelectionChanges(e);
  }

  private _initForm() {
    this._form = this._fb.group({
      code: [this._model ? this._model.code : null, Validators.required],
      unitName: [
        this._model ? this._model.unitName : null,
        this.getLabel('LBL_UOMUnitName')?.isRequired
          ? Validators.required
          : null,
      ],
      multiplier: [
        this._model ? this._model.multiplier : null,
        Validators.required


      ],
    });
  }

  saveresponsthenclose: any = null;

  private submit = (e: string) => {
    var sitesSelected: boolean = true;
    if (this._currentUser.isEnterprise) {
      if (this._currentUser.isEnterprise && this._selectedAccounts.length === 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please select account(s) to continue.',
        });
        return false;
      }
      else {
        var tmpAccountSites = this._selectedAccounts.filter(
          (x: any) => x.siteId != -1
        );
        if (tmpAccountSites.length != this._selectedAccounts.length) {
          this._layoutComponent.openPopup({
            title: 'Validation',
            message: 'Please select the site(s) of the selected account(s) to continue.',
          });
          sitesSelected = false;
          return false;
        }
      }
    }
    if (this._form.invalid && this._customValidation.find((x: any) => !x.value)) {
      this._invalidForm = true;
      this._invalidSubmit = true;
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
    } else if (this._form.invalid) {
      this._invalidForm = true;
    } else if (this._customValidation.find((x: any) => !x.value)) {
      this._invalidForm = true;
      this._invalidSubmit = true;
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
    } else {
      // work with custom fields
      if (this._customFieldsValue) {
        /* const entries = Object.entries(this._customFieldsValue);
        for (const [index, [key, value]] of entries.entries()) {
          this._customFieldsDictionary[key] = `${value}`;
        } */
        this._customFieldsValue.forEach((elementy: any) => {
          this._customFieldsDictionary[elementy.Key] = elementy.Value;
        });
      }
      //

      this._invalidForm = false;
      this._invalidSubmit = false;
      const model = this._form.value;

      /* if (model.multiplier < 1) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose a multiplier equal to or greater than 1.',
          withoutConfirm: true
        });
        this._invalidForm = true;
        return;
      }
      if (Math.trunc(model.multiplier) < model.multiplier || model.multiplier < 1) {
        this._layoutComponent.openPopup({
          title: 'Warning',
          message: 'Are you sure to proceed with adding a decimal multiplier?',
          withoutConfirm: false
        });
        this._invalidForm = true;
      }*/
      model['multiplier'] = Number(model.multiplier)?.toFixed(this.digitNumber);
      model['customFieldsValue'] = this._customFieldsDictionary;
      model['accountIds'] = this._selectedAccounts.map((c: any) => (c?.accountId != null ? +c.accountId : +c));
      if (this._pageState == PageState.EDIT) {
        if (this._model.id == null) {
          this._model.id = model.id;
        }
        this._unitOfMeasuresService
          .updateUnitOfMeasure(this._model.id, model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {

              // this.note.createNote(response.id);
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  model.id = this._model.id;
                  this._unitOfMeasuresService.UOMUpdated.emit(model);
                  if (e === 'saveAndClose') {
                    this._closeForm(response);
                  } else if (e === 'saveAndCopy') {
                    this.copyModelId = this._model.id;
                    this._form.controls.code.setValue(null);
                    this._pageState = PageState.ADD;
                    this.loadCustomFields();
                  }
                  else if (e === 'save') {
                    this._pageState = PageState.EDIT;
                  }
                  else if (e === 'saveAndNew') {
                    this._initForm();
                    this._form.reset();
                    this._pageState = PageState.ADD;
                  }
                } else {
                  return;
                }
              }
            }
          });
      } else {
        this._unitOfMeasuresService
          .createUnitOfMeasure(model)

          .subscribe((response: any) => {
            model.id = response.responseId;
            this._unitOfMeasuresService.UOMAdded.emit(model);
            this.saveresponsthenclose = model;
            if (response != null && response['message'] != null) {
              //if (this._currentUser && !this._currentUser.isEnterprise)
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  if (e === 'saveAndClose') {
                    model.id = response.responseId;
                    this._closeForm(model);
                  } else if (e === 'saveAndCopy') {

                    this._form.controls.code.setValue(null);
                    this._pageState = PageState.ADD;
                    // this.loadCustomFields();
                  }
                  else if (e === 'save') {
                    this._pageState = PageState.EDIT;
                    this._model.id = response['responseId'];
                    this.LoadUnitOfMeasureChart();
                  }
                  else if (e === 'saveAndNew') {
                    this._initForm();
                    this._form.reset();
                    this._pageState = PageState.ADD;
                  }
                } else {
                  return;
                }
              }
            }
            //this._closeForm();
          });

        this.saveresponsthenclose = null;
      }
    }
  };

  private loadCustomFields(entityId?: string) {
    entityId = this.copyModelId?.toString() ?? this._model?.id?.toString();
    this._customFieldsService
      .getCustomFields('stock', this._page, entityId)

      .subscribe((data) => {
        if (this._model != null && this._model.id != null || this.copyModelId != null) {
          let that = this;
          data.map(function (x) {
            x.entityId = that._model.id ?? that.copyModelId;
          });
        }
        var tabIds = data
          .map((item) => item.formTabId)
          .filter((value, index, self) => self.indexOf(value) === index);

        const grouped = this.groupBy(
          data,
          (item: { formTabId: any }) => item.formTabId
        );
        let that = this;
        tabIds.forEach(function (formTabId) {
          that._customFields[formTabId] = grouped.get(formTabId);
        });
        if (this.copyModelId) {
          let CustomFieldsDataForCopy: any = {};
          grouped.forEach(element => {
            element.forEach((value: any) => {

              let _cutomfieldData = value.customFieldsData?.find((f: any) => f.entityId == entityId);
              CustomFieldsDataForCopy[value.name] = _cutomfieldData?.value ?? null;
              if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
              if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
            });
            this._customFieldsValueChanges(CustomFieldsDataForCopy, null);

          });
        }
        this._customFieldsService
          .getFormTabsByPage(this._page)

          .subscribe((data: any) => {
            //get custom tabs first
            this._customTabs = data.filter(
              (x: { isCustom: boolean }) => x.isCustom == true
            );
            this.setMandatoryFields();
          });
      });

  }

  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {

    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };
      let item = null;
      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });
      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);
        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }
      var requiredCustomerField = this._customValidation.find(
        (x: any) => x.name == key
      );
      if (requiredCustomerField) {
        let item2 = null;
        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });
        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);
          if (index2 != -1) {
            //this._customValidation.splice(index2, 1);
            this._customValidation[index2].value = customObject.Value;
          }
          //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
        }
      }
      this._additionalErrors = [];
      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }

      this._customFieldsValue.push(customObject);
    });
  }

  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (
          this._customFields[i].findIndex((x) => x.id == customFieldId) != -1
        ) {
          this._customFields[i] = this._customFields[i].filter(
            (x) => x.id != customFieldId
          );
          return;
        }
      }
    }
  }
  _viewInactiveFormTabs(onLoad: boolean = false) {
    this._customFieldsService
      .getDeactivatedCustomForms(this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFormTabsGridData = data;
        //  if(!onLoad)
        //  this._deactivatedFormTabsForm = true;
      });
  }
  reactivateTab: boolean;
  _reactivateFormTab(item: any) {
    this.reactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      this.reactivateTab = true;
      if (boolData && this.reactivateTab) {
        // if (boolData && this.reactivateTab && (this.lastTabIdReactivated.length == 0 || !this.lastTabIdReactivated.includes(item.id))) {
        this.reactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService
          .reactivateFormTab(item.id, model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              // if (this.lastTabIdDeactivated.includes(item.id)) {
              //   this.lastTabIdDeactivated = this.lastTabIdDeactivated.filter(id => id !== item.id);
              // }
              // this.lastTabIdReactivated.push(item.id);
              this._viewInactiveFormTabs(false)
              this._customFieldsService
                .getFormTabsByPage(this._page)

                .subscribe((data: any) => {
                  //get custom tabs first
                  this.getFormTabs();
                  this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
                });
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                } else {
                  return;
                }
              }
            }
          });
      } else {
        this.reactivateTab = false;
      }
      sub.unsubscribe();
    });


    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }
  _closeInactiveFormTabs() {
    this._deactivatedFormTabsForm = false;
  }
  // lastTabIdDeactivated:number[] = []
  // lastTabIdReactivated:number[] = []
  //#endregion
  deactivateTab: boolean
  _deactivateTab(tabId: number, page: string) {
    this.deactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      if (boolData && this.deactivateTab) {
        // if (boolData && this.deactivateTab && (this.lastTabIdDeactivated.length == 0 || !this.lastTabIdDeactivated.includes(tabId))) {
        this.deactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService.deleteCustomTab(tabId, model).subscribe((response: any) => {
          // this.lastTabIdDeactivated.push(tabId);
          // if (this.lastTabIdReactivated.includes(tabId)) {
          //   this.lastTabIdReactivated = this.lastTabIdReactivated.filter(id => id !== tabId);
          // }

          if (response != null && response['message'] != null) {
            this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
              //get custom tabs first
              this.getFormTabs();
              this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
            });

            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                // this._closeForm();
              }
              else {
                return;
              }
            }
          }
        });
      } else {
        this.deactivateTab = true;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Deactivate This Tab?',
    });

  }


  // _deactivateTab(tabId: number, page: string) {

  //   let model: any = {
  //     customFieldEntityId: page == 'uom' ? 1 : 2,
  //     page: this._page,
  //     accountIds: this._selectedAccountIds,
  //   };
  //     .deleteCustomTab(tabId, model)
  //     
  //     .subscribe((response: any) => {
  //       if (response != null && response['message'] != null) {
  //           .getFormTabsByPage(this._page)
  //           
  //           .subscribe((data: any) => {
  //             //get custom tabs first
  //             this._customTabs = data.filter(
  //               (x: { isCustom: boolean }) => x.isCustom == true
  //             );
  //           });
  //         this._layoutComponent.openPopup({
  //           title: 'Alert',
  //           message: response['message'],
  //           withoutConfirm: true
  //         });
  //         if (response['close'] != null) {
  //           if (response['close'] == true) {
  //             // this._closeForm();
  //           } else {
  //             return;
  //           }
  //         }
  //       }
  //       //   this._closeForm();
  //     });
  // }

  private loadLabels() {
    this._gridFields
      .getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this._gridFieldText = data;
        this._initForm();
      });
  }

  getLabel(objectCode: any) {
    if (this._gridFieldText) {
      if (
        this._gridFieldText.find(
          ({ gridFieldDefinition }) =>
            gridFieldDefinition?.objectCode === objectCode
        )
      )
        var result = this._gridFieldText.find(
          ({ gridFieldDefinition }) =>
            gridFieldDefinition?.objectCode === objectCode
        );
      else result = null;

      return result ? result : null;
    }
  }

  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }

  getNotes(fileId: number, page: string) {
    this._notesService
      .getNotesByPage(fileId, page)

      .subscribe((x: NoteSummary[]) => {
        this._notes = x;
      });
  }

  editableNote(note: any) {
    this._editableNote = note;
  }

  processEditNote(i: number) {
    this._isEditNote = !this._isEditNote;
    this._index = i;
  }

  _reorderingtabs() {
    this._orderingTabsForm = true;
  }
  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }

  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find((x) => x.order == i + 1)) {
      this._userNewDataTabs.find(
        (x) => x === this._dataTabsSelected.find((x) => x.order == i + 1)
      ).order = this._dataTabsSelected.find((x) => x.name === e.name).order;
    }
    this._userNewDataTabs.find((obj) => obj.name == e.name).order = i + 1;
    this._dataTabsSelected = this._dataTabsSelected.filter((obj) => obj !== e);
  }

  _onSaveTabOrdering() {
    this._gridFields
      .updateFormTabsReorder(this._userNewDataTabs)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._closeOrderingTabsForm();
      });
  }

  //#region  getFormTabs
  getFormTabs() {
    this._gridFields
      .getformTabsByPage(this._page)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._userNewDataTabs = x;
        //this.sortProduct(p => p.order, "ASC");
      });
  }
  //#endregion
  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields
      .getFieldsAuthorization(this._page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (
        this._gridFieldAuth.find(
          ({ gridFieldDefinition }) =>
            gridFieldDefinition?.objectCode === objectCode
        )
      )
        var result = this._gridFieldAuth.find(
          ({ gridFieldDefinition }) =>
            gridFieldDefinition?.objectCode === objectCode
        );
      else result = null;

      return result ? result : new GridFieldAuthorization();
    }
  }

  //#region  getSystemFields
  getSystemFields() {
    this._gridFields
      .getSystemFieldsByPage(this._page)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
      });

  }
  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
        this.loadCustomFields(this._model?.id?.toString());
        //this.setMandatoryFields();
      })

  }
  //#endregion

  //#region  setMandatoryFields
  requiredSystemTabs: any = [];
  setMandatoryFields() {
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];
    setTimeout(() => {
      for (let item of this._systemFields) {
        if (item.gridFieldText.isRequired) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired) {
              this._requiredFields.push(item3);
            }
          }
        }
      }
      this._requiredFields.forEach(element => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);
            if (SystemFieldTab)
              this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });
      if (this.navTrigger) {
        let tabElementList = this.navTrigger.nativeElement.querySelector('ul');
        Array.from(tabElementList.children).forEach((child: any) => {

          child.classList.remove('mendatoryTab');
        });
        Array.from(tabElementList.children).forEach((child: any) => {

          if (this._requiredFieldNames.find(x => x.name === child.firstChild.innerText && (x.page ? x.page == this._page : x.formtab.page == this._page))) {
            child.classList.add("mendatoryTab")
          }
          if (
            this.requiredSystemTabs.find(
              (x: any) =>
                x.name === child.firstChild.innerText
            )
          ) {
            child.classList.add('mendatoryTab');
          }
        });
      }
      this._requiredFields.forEach((element) => {
        if (element.customFieldType) {
          this._customRequiredFields.push(element);
          let thisvalue =
            element.customFieldsData.filter(
              (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
            ).length > 0
              ? element.customFieldsData.filter(
                (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
              )[0].value
              : '';
          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });
        }
      });


    }, 500);

  }
  //#endregion
  _onEditForms() {
    this._isEditForms = true;
  }

  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }

  getStateString(siteShip: any) {
    let accounts = '';
    let counter = 0;
    siteShip.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.address.state;
      counter++;
    });

    return accounts;
  }

  getCountryString(siteShip: any) {
    let accounts = '';
    let counter = 0;
    siteShip.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.address.country;
      counter++;
    });

    return accounts;
  }

  getZipString(siteShip: any) {
    let accounts = '';
    let counter = 0;
    siteShip.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.address.zip;
      counter++;
    });

    return accounts;
  }

  getCityString(siteShip: any) {
    let accounts = '';
    let counter = 0;
    siteShip.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.address.city;
      counter++;
    });

    return accounts;
  }

  getAddress1String(siteShip: any) {
    let accounts = '';
    let counter = 0;
    siteShip.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.address.addressLine1;
      counter++;
    });

    return accounts;
  }

  getAddress2String(siteShip: any) {
    let accounts = '';
    let counter = 0;
    siteShip.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.address.addressLine2;
      counter++;
    });

    return accounts;
  }

  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }

  _hasCustomTabs() {
    return this._dataTabs.find((x: any) => x.isCustom);
  }
  _activateReceiveChart() {
    this._receiveChartActive = true;
    this._issueChartActive = false;
    this._inventoryChartActive = false;
  }
  _activateIssueChart() {
    this._receiveChartActive = false;
    this._issueChartActive = true;
    this._inventoryChartActive = false;
  }
  _activateInventoryChart() {
    this._receiveChartActive = false;
    this._issueChartActive = false;
    this._inventoryChartActive = true;
  }
}
